import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { useParams } from 'next/navigation'
import {
  QUERY_HOTEL_PLAN_LIST_KEY,
  QUERY_HOTEL_PLAN_RESALE_LIST_KEY,
  fetchHotelPlans,
} from './fetchHotelPlans'
import useAuthentication from '../useAuthentication'
import type { PlanListItemModel } from 'core/bookings/types'

function useQueryHotelPlanList(
  hotelCode: string,
  hotelPlanCodes?: string[],
  showResale?: boolean,
  enabled?: boolean,
): UseQueryResult<PlanListItemModel[] | null> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { withTriplaApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [
      showResale ? QUERY_HOTEL_PLAN_RESALE_LIST_KEY : QUERY_HOTEL_PLAN_LIST_KEY,
      {
        hotelCode,
        locale,
        hotelPlanCodes,
      },
    ],
    queryFn: withTriplaApiRequest(fetchHotelPlans),
    enabled,
  })
}

export default useQueryHotelPlanList
